<template>
	<div id="grid-two-col">
		<ul v-if="getGridTwoCol.length > 0" :class="[ 'grid grid-cols-1 sm:grid-cols-2' ]">
			<li v-for="(item, index) in getGridTwoCol" :key="index" :class="['transform scale-100 opacity-100']">

				<!-- For text -->
				<template v-if="item.text">
					<p class="text h-full flex flex-col items-center justify-center py-5 sm:py-10" v-html="item.text"></p>
				</template>

				<!-- For an image -->
				<template v-if="typeof item.img === 'string' && item.img !== ''">
					<picture v-if="item.img">
						<img :src="require(`@/img/${item.img}`)" :alt="item.title" />
					</picture>
				</template>
			</li>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'GridTwoColumn',
	computed: {
		...mapGetters([ 'getGridTwoCol' ]),
	},
	data: function() {
		return {
			data: '',
		}
	},
	methods: {

	},
}
</script>

<style>

</style>
